import PropTypes from 'prop-types'
import { Component } from 'react'

import { agent, bootstrapAgent } from 'agent'
import { isPersistedSessionHeader } from 'context/auth-context-utils'
import { withAuthContext } from 'context/with-auth-context'
import supportAgent from 'support/API'
import SupportAPI from 'SupportAPI'
import { sanitize, messageFromResponseError } from 'utils/strings'

class AgentContainer extends Component {
  static propTypes = {
    authState: PropTypes.object
  }

  renewalPromise = null

  componentDidMount() {
    bootstrapAgent()

    // Set up interceptors for agent
    const authInterceptor = (config) => {
      if (config.headers.Authorization) return config

      if (this.props.authState.authHeader)
        config.headers.Authorization = this.props.authState.authHeader

      return config
    }

    agent.interceptors.request.use(authInterceptor)

    agent.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(agent)
    )

    // LEGACY SUPPORT API
    supportAgent.interceptors.request.use(authInterceptor)

    supportAgent.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(supportAgent)
    )

    // NEW SUPPORT API
    SupportAPI.interceptors.request.use(authInterceptor)

    SupportAPI.interceptors.response.use(
      undefined,
      this.handleUnauthorizedResponse(supportAgent)
    )
  }

  handleUnauthorizedResponse = (axiosInstance) => (err) => {
    const { authState } = this.props

    const message = messageFromResponseError(err)
    if (message) {
      err.response.data = sanitize(message)
    }

    if (
      !err.config ||
      (err.response &&
        err.response.status !== 401 &&
        err.response.status !== 403)
    ) {
      throw err
    }

    const isIgnoredRequest =
      err.config.url === '/users/auth' && err.config.method === 'delete'

    // if the message is "token expired" and the current request is not a delete on users/auth
    if (message === 'Authentication token is expired' && !isIgnoredRequest) {
      // This header is bad, get rid of it
      delete err.config.headers.Authorization
      // If there is no pending renewal promise, start it. This avoids
      // sending duplicate renewal requests if multiple requests fail within
      // a short timeframe.
      if (!this.renewalPromise) this.renewalPromise = authState.renewSession()

      // After the renewal is done, retry the pending request
      return this.renewalPromise.then(() => {
        this.renewalPromise = null
        return axiosInstance(err.config)
      })
    } else if (
      message === 'Authentication token is invalid' ||
      message === 'Session not found' ||
      message === 'Identity not found' ||
      message === 'Session has been revoked' ||
      message === 'The trial for your company has expired' ||
      message === 'Identity has been deactivated' ||
      message === "Session doesn't exist"
    ) {
      // A token a renewal already replaced fails here, and the renewed session stays saved.
      if (isPersistedSessionHeader(err.config.headers.Authorization))
        authState.endSession()
    }

    throw err
  }

  render() {
    return null
  }
}

export default withAuthContext(AgentContainer)
